import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actionCreators, fetchSelector} from 'actions'
import api from 'api'
import {Redirect} from 'react-router-dom'
import withRouterLegacy from 'withRouterLegacy'
import CommentModal from 'procedures/CommentModal'
import {isEmpty} from 'lodash'
import {formMap} from 'procedureStatuses/ReportEdit'
import queryString from 'query-string'
import Completed from 'procedures/enroll/EmployeeInputCompleted'
import {reflectEnrollmentInputToken} from 'libs/enrollmentInputToken'
import {notifySuccess} from 'store/actions/notify'
import {asyncError} from 'store/actions/asyncError'
import {flow} from 'lodash/fp'
import {getR150ReportValues} from './tmpData'

const NOT_LOGIN_PATH = '/enrollment_employee_input_dependents/:id'

class InputDependents extends Component {
  static defaultProps = {
    tmpData: {},
  }

  constructor(props) {
    super(props)
    this.state = {
      querying: true,
      valid: null,
      error: false,
      formIndex: -1,
    }
  }

  componentDidMount() {
    const {
      match: {
        params: {id},
      },
      token,
      loadProcedureStatus,
      loadTmpData,
      loadComments,
    } = this.props
    loadProcedureStatus(id, token)
    loadTmpData(id, token)
    loadComments(id, token)
  }

  componentDidUpdate() {
    const {
      location: {search},
    } = this.props
    const {dependent_index} = queryString.parse(search)
    const dependentIndex = dependent_index | 0
    if (+dependentIndex !== this.state.formIndex) {
      this.setState({formIndex: dependentIndex})
    }
  }

  componentWillUnmount() {
    this.props.destroy()
  }

  handleFormSubmit = (values, comment) => {
    const {
      saveAndNext,
      location: {search},
      match: {
        params: {id},
        path,
      },
      tmpData,
      token,
    } = this.props
    const {dependent_index} = queryString.parse(search)
    const {dependents} = tmpData.employee ? JSON.parse(tmpData.employee.data) : {dependents: []}
    const socialInsuranceDependents = dependents.filter((dependent) => dependent.dependent_social_insurance)
    return saveAndNext(
      id,
      token,
      values,
      comment,
      +dependent_index,
      +dependent_index + 1 >= socialInsuranceDependents.length,
      path !== NOT_LOGIN_PATH,
      this.props.history
    )
  }

  render() {
    const {
      tmpData,
      loading,
      location: {search},
      match: {
        params: {id},
      },
      path,
      procedureStatus,
      comments,
    } = this.props
    const {enrollment_input_token: token, dependent_index} = queryString.parse(search)
    const dependentIndex = dependent_index | 0
    const isLogin = path !== NOT_LOGIN_PATH
    if (loading || !tmpData.employee) {
      return null
    }
    if (!procedureStatus.id) {
      return null
    }

    if (['applying', 'accepted'].includes(procedureStatus.application_status)) {
      return <Completed afterInput />
    }
    const values = tmpData.employee ? JSON.parse(tmpData.employee.data) : {}
    const socialInsuranceDependents = values.dependents.filter((dependent) => dependent.dependent_social_insurance)
    if (isEmpty(socialInsuranceDependents)) {
      return (
        <Redirect
          to={
            isLogin
              ? `/enroll/employee_input/${id}`
              : `/enrollment_employee_input/${id}?enrollment_input_token=${token}`
          }
        />
      )
    }
    if (dependentIndex > socialInsuranceDependents.length || dependentIndex < 0) {
      return (
        <Redirect
          to={
            isLogin
              ? `/enroll/employee_input_dependents/${id}?dependent_index=0`
              : `/enrollment_employee_input_dependents/${id}?enrollment_input_token=${token}&dependent_index=0`
          }
        />
      )
    }
    const dependent = socialInsuranceDependents[dependentIndex]
    const reportType = 'R150'
    const formName = 'R150Report'
    const Report = formMap[reportType]
    const isFinal = dependentIndex + 1 >= socialInsuranceDependents.length
    const r150ReportValues = getR150ReportValues(
      tmpData,
      dependent,
      dependentIndex,
      values.dependents,
      socialInsuranceDependents
    )

    const initialValues = {
      _id: dependent._id,
      ...r150ReportValues,
      application_reason_type: r150ReportValues?.application_reason_type || 'entrance',
      reportType,
    }

    if (dependentIndex !== this.state.formIndex) return null
    return (
      <CommentModal
        formName={formName}
        procedureType="enroll"
        onSubmit={({values, comment}) => this.handleFormSubmit(values, comment)}
        comments={comments || []}
      >
        {({showModal}) => (
          <Report
            key={dependentIndex}
            onSubmit={isFinal ? showModal : this.handleFormSubmit}
            submitText={isFinal ? '完了' : '次へ'}
            skipLoad
            name={`${dependent.last_name} ${dependent.first_name}`}
            relation_type={dependent.relation_type}
            relation_other={dependent.relation_other}
            comments={comments || {}}
            initialValues={initialValues}
          />
        )}
      </CommentModal>
    )
  }
}

export default flow(
  connect(
    (state) => ({
      token: state.auth.token,
      tmpData: state.procedureStatuses.tmpData.data,
      comments: fetchSelector(state, 'procedure_comments').data,
      loading: state.procedureStatuses.current.loading || state.procedureStatuses.tmpData.loading,
      procedureStatus: state.procedureStatuses.current.data,
    }),
    (dispatch) => ({
      loadProcedureStatus(id, token) {
        dispatch(
          actionCreators.procedureStatuses.current.fetchData(api.createWithAuth(token).procedureStatuses.get(id))
        )
      },
      destroy() {
        dispatch(actionCreators.procedureStatuses.current.destroy())
        dispatch(actionCreators.procedureStatuses.tmpData.destroy())
      },
      loadTmpData(procedureStatusId, token) {
        dispatch(
          actionCreators.procedureStatuses.tmpData.fetchData(
            api.createWithAuth(token).procedureStatuses.tmpData.mapByName(procedureStatusId, 'application')
          )
        )
      },
      loadComments: (procedureStatusId, token) => {
        dispatch(
          actionCreators.fetchData(
            'procedure_comments',
            api.createWithAuth(token).procedureStatuses.procedureComments.list(procedureStatusId)
          )
        )
      },
      async saveAndNext(procedureStatusId, token, values, comment, dependentIndex, isFinal, isLogin, history) {
        try {
          const authedApi = api.createWithAuth(token)
          await authedApi.procedureStatuses.tmpData.updateJson(
            procedureStatusId,
            'application',
            'report_params_sets', // 家族対応でreport_params_setsに変更。それ以前はdependent_info_${dependentIndex}
            (data) => ({
              ...data,
              [values._id]: {
                r150_param_set: values,
              },
            })
          )
          if (isFinal) {
            await authedApi.procedureStatuses.apply(procedureStatusId, comment)
            history.push(isLogin ? '/dashboard' : '/enrollment_employee_input_completed')
            dispatch(notifySuccess('提出しました'))
          } else {
            history.push(
              isLogin
                ? `/enroll/employee_input_dependents/${procedureStatusId}?dependent_index=${dependentIndex + 1}`
                : `/enrollment_employee_input_dependents/${procedureStatusId}?enrollment_input_token=${token}&dependent_index=${
                    dependentIndex + 1
                  }`
            )
            dispatch(notifySuccess('保存しました'))
            window.scrollTo(0, 0)
          }
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
    })
  ),
  reflectEnrollmentInputToken(NOT_LOGIN_PATH),
  withRouterLegacy
)(InputDependents)
